/**
 * GLightbox init for gallery-style components (latest work, creative gallery,
 * social-media case studies). The glightbox script is enqueued by those components.
 */
document.addEventListener('DOMContentLoaded', function () {
    if (typeof GLightbox === 'undefined') return;

    function init(selector) {
        if (!document.querySelector(selector)) return;
        var lightbox = GLightbox({
            selector: selector,
            touchNavigation: true,
            loop: true,
            zoomable: true
        });
        lightbox.on('open', function () {
            if (document.activeElement && document.activeElement.classList.contains('glightbox')) {
                document.activeElement.blur();
            }
        });
    }

    // Social-media case study grid is its own gallery
    init('.sm-item.glightbox');
    init('.glightbox:not(.sm-item)');
});
